<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h5">
            {{ title }}
          </v-card-title>

          <v-card-text>
            <!-- Are you sure you want to delete this message? -->
            <span v-html="message"></span>
            <!-- {{ message }} -->
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="actionResponse(false)">
              No
            </v-btn>
            <v-btn color="primary" @click="actionResponse(true)">
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["dialog", "message", "title"],

  methods: {
    actionResponse(val) {
      this.$emit("response", val);
    },
  },
};
</script>
